export default function Arcade(props) {
  return (
    <svg
      id="Component_32_26"
      data-name="Component 32 – 26"
      xmlns="http://www.w3.org/2000/svg"
      width="21.703"
      height="20"
      viewBox="0 0 21.703 20"
      {...props}>
      <path
        id="Path_5775"
        data-name="Path 5775"
        d="M412.409,28.339a10.024,10.024,0,0,1,7.968-9.765,9.693,9.693,0,0,1,9.044,2.663,1.623,1.623,0,0,1,.362,2,2.236,2.236,0,0,1-.565.659c-1.6,1.273-3.205,2.53-4.811,3.791-.58.455-.588.9-.013,1.356q2.376,1.887,4.754,3.772a1.715,1.715,0,0,1,.136,2.8c-.2.189-.4.373-.617.544a9.975,9.975,0,0,1-16.042-5.987C412.516,29.565,412.48,28.949,412.409,28.339Zm13.1-5.747a1.353,1.353,0,0,0-1.361-1.366,1.359,1.359,0,1,0,.017,2.718A1.346,1.346,0,0,0,425.51,22.592Z"
        transform="translate(-412.409 -18.351)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5776"
        data-name="Path 5776"
        d="M589.334,99.378a.906.906,0,1,1-.912-.89A.909.909,0,0,1,589.334,99.378Z"
        transform="translate(-567.63 -89.385)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5777"
        data-name="Path 5777"
        d="M530.014,99.4a.9.9,0,1,1,.891.907A.906.906,0,0,1,530.014,99.4Z"
        transform="translate(-516.655 -89.39)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5778"
        data-name="Path 5778"
        d="M560.511,99.437a.9.9,0,0,1-.894.905.917.917,0,0,1-.915-.921.9.9,0,0,1,.885-.883A.884.884,0,0,1,560.511,99.437Z"
        transform="translate(-542.085 -89.429)"
        fill="#f7f7f7"
      />
    </svg>
  );
}
